module.exports = __webpack_public_path__ + "img/40_38_056_720.d8267e21.jpg";